// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
// import { fetchEmployerData, verifyEmployer } from "./EmployerDataAPI"

// const initialState = {
//     data: [],
//     allEmployers: [], // New field to store all employers for dropdowns
//     pagination: {
//         current_page: 1,
//         last_page: 1,
//         total: 0,
//     },
//     loading: false,
//     error: null,
// }

// export const fetchEmployerDataAsync = createAsyncThunk("employer/fetch", async (page, { rejectWithValue }) => {
//     try {
//         return await fetchEmployerData(page)
//     } catch (error) {
//         return rejectWithValue(error.message)
//     }
// })

// // New async thunk to fetch all employers for dropdowns
// export const fetchAllEmployersAsync = createAsyncThunk("employer/fetchAll", async (_, { rejectWithValue }) => {
//     try {
//         let allEmployers = []
//         let currentPage = 1
//         let lastPage = 1

//         // Fetch first page to get pagination info
//         const firstPageData = await fetchEmployerData(1)
//         allEmployers = [...firstPageData.candidates]
//         lastPage = firstPageData.pagination.last_page

//         // Fetch remaining pages if there are more
//         const fetchPromises = []
//         for (let page = 2; page <= lastPage; page++) {
//             fetchPromises.push(fetchEmployerData(page))
//         }

//         if (fetchPromises.length > 0) {
//             const remainingPages = await Promise.all(fetchPromises)
//             remainingPages.forEach(pageData => {
//                 allEmployers = [...allEmployers, ...pageData.candidates]
//             })
//         }

//         return allEmployers
//     } catch (error) {
//         return rejectWithValue(error.message)
//     }
// })

// export const verifyEmployerAsync = createAsyncThunk(
//     "employer/verify",
//     async ({ uuid, verifyData }, { rejectWithValue }) => {
//         try {
//             const response = await verifyEmployer(uuid, verifyData)
//             return { uuid, ...response }
//         } catch (error) {
//             return rejectWithValue(error.message)
//         }
//     }
// )

// const EmployerDataSlice = createSlice({
//     name: "employerData",
//     initialState,
//     reducers: {},
//     extraReducers: (builder) => {
//         builder
//             .addCase(fetchEmployerDataAsync.pending, (state) => {
//                 state.loading = true
//                 state.error = null
//             })
//             .addCase(fetchEmployerDataAsync.fulfilled, (state, action) => {
//                 state.loading = false
//                 state.data = action.payload.candidates
//                 state.pagination = action.payload.pagination
//             })
//             .addCase(fetchEmployerDataAsync.rejected, (state, action) => {
//                 state.loading = false
//                 state.error = action.payload
//             })
//             .addCase(fetchAllEmployersAsync.pending, (state) => {
//                 state.loading = true
//                 state.error = null
//             })
//             .addCase(fetchAllEmployersAsync.fulfilled, (state, action) => {
//                 state.loading = false
//                 state.allEmployers = action.payload
//             })
//             .addCase(fetchAllEmployersAsync.rejected, (state, action) => {
//                 state.loading = false
//                 state.error = action.payload
//             })
//             .addCase(verifyEmployerAsync.pending, (state) => {
//                 state.loading = true
//                 state.error = null
//             })
//             .addCase(verifyEmployerAsync.fulfilled, (state, action) => {
//                 state.loading = false
//                 const updatedCandidate = action.payload
//                 state.data = state.data.map((candidate) =>
//                     candidate.uuid === updatedCandidate.uuid ? { ...candidate, is_verified: true } : candidate,
//                 )
//                 // Also update in allEmployers if it exists
//                 state.allEmployers = state.allEmployers.map((employer) =>
//                     employer.uuid === updatedCandidate.uuid ? { ...employer, is_verified: true } : employer,
//                 )
//             })
//             .addCase(verifyEmployerAsync.rejected, (state, action) => {
//                 state.loading = false
//                 state.error = action.payload
//             })
//     }
// })

// export const selectEmployerData = (state) => state.employerData.data
// export const selectAllEmployers = (state) => state.employerData.allEmployers // New selector
// export const selectPagination = (state) => state.employerData.pagination

// export default EmployerDataSlice.reducer

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { fetchEmployerData, fetchEmployerList, verifyEmployer } from "./EmployerDataAPI"

const initialState = {
    data: [],
    allEmployers: [], // Stores employers for dropdown, fetched paginated
    employerDropdownPagination: {
        currentPage: 0,
        lastPage: 1,
        hasMore: true,
    },
    isFetchingMoreEmployers: false, // New state for dropdown loading
    pagination: {
        current_page: 1,
        last_page: 1,
        total: 0,
    },
    loading: false,
    error: null,
}

export const fetchEmployerDataAsync = createAsyncThunk("employer/fetch", async (page, { rejectWithValue }) => {
    try {
        return await fetchEmployerList(page)
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

// New async thunk to fetch employers for dropdowns with pagination
export const fetchEmployersForDropdownAsync = createAsyncThunk(
    "employer/fetchForDropdown",
    async (page, { rejectWithValue }) => {
        try {
            const response = await fetchEmployerData(page) // Reuse existing paginated API
            return response
        } catch (error) {
            return rejectWithValue(error.message)
        }
    },
)

export const verifyEmployerAsync = createAsyncThunk(
    "employer/verify",
    async ({ uuid, verifyData }, { rejectWithValue }) => {
        try {
            const response = await verifyEmployer(uuid, verifyData)
            return { uuid, ...response }
        } catch (error) {
            return rejectWithValue(error.message)
        }
    },
)

const EmployerDataSlice = createSlice({
    name: "employerData",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployerDataAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(fetchEmployerDataAsync.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload.candidates
                state.pagination = action.payload.pagination
            })
            .addCase(fetchEmployerDataAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
            // Cases for fetching employers for dropdown
            .addCase(fetchEmployersForDropdownAsync.pending, (state) => {
                state.isFetchingMoreEmployers = true
                state.error = null
            })
            .addCase(fetchEmployersForDropdownAsync.fulfilled, (state, action) => {
                state.isFetchingMoreEmployers = false
                const { candidates, pagination } = action.payload
                const currentPage = pagination.current_page
                state.allEmployers = currentPage === 1 ? candidates : [...state.allEmployers, ...candidates]
                state.employerDropdownPagination.currentPage = pagination.current_page
                state.employerDropdownPagination.lastPage = pagination.last_page
                state.employerDropdownPagination.hasMore = pagination.current_page < pagination.last_page
            })
            .addCase(fetchEmployersForDropdownAsync.rejected, (state, action) => {
                state.isFetchingMoreEmployers = false
                state.error = action.payload
            })
            .addCase(verifyEmployerAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(verifyEmployerAsync.fulfilled, (state, action) => {
                state.loading = false
                const updatedCandidate = action.payload
                state.data = state.data.map((candidate) =>
                    candidate.uuid === updatedCandidate.uuid ? { ...candidate, is_verified: true } : candidate,
                )
                // Also update in allEmployers if it exists
                state.allEmployers = state.allEmployers.map((employer) =>
                    employer.uuid === updatedCandidate.uuid ? { ...employer, is_verified: true } : employer,
                )
            })
            .addCase(verifyEmployerAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
    },
})

export const selectEmployerData = (state) => state.employerData.data
export const selectAllEmployers = (state) => state.employerData.allEmployers
export const selectPagination = (state) => state.employerData.pagination
export default EmployerDataSlice.reducer
